import { render, staticRenderFns } from "./gruposproveedor.vue?vue&type=template&id=763d6d8a"
import script from "./gruposproveedor.vue?vue&type=script&lang=js"
export * from "./gruposproveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports